export const getUrl = (pathSegments: string[]) => {
  return pathSegments.join('/');
};

export const buildResizedImageUrl = (path: string, opts: { width?: number; height?: number } = {}) => {
  if (!opts.width && !opts.height) return path;

  const params = new URLSearchParams();
  if (opts.width) params.set('w', String(opts.width));
  if (opts.height) params.set('h', String(opts.height));

  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}${params.toString()}`;
};
